import { Component, OnInit } from '@angular/core';
import { SkillService } from '../services/skill.service';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators } from '@angular/forms';
import { Department } from '../api-interfaces';
import { Location } from '@angular/common';
import 'rxjs/add/operator/takeUntil';
import { Subject, Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { FlashService } from '../../flash/flash.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-edit-category',
  templateUrl: './edit-category.component.html',
  styleUrls: ['./edit-category.component.css']
})
export class EditCategoryComponent implements OnInit {
  departments: Observable<Department[]>;
  editData;
  categoryForm: FormGroup;
  private destroy: Subject<void> = new Subject<void>();
  id: number;
  private sub: any;
  deptId;
  constructor(
    public skillService: SkillService,
    private location: Location,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private flashService: FlashService,
    private spinnerService: Ng4LoadingSpinnerService
  ) {
    this.departments = this.skillService.getDepartment();
    this.categoryForm = this.formBuilder.group({
      category_name: new FormControl('', Validators.required),
      category_id: new FormControl('', Validators.required),
      department_id: new FormControl('', [Validators.required])
    });
  }

  ngOnInit() {
    // this.spinnerService.show();
    this.sub = this.route.params.subscribe(params => {
      this.id = +params['id'];
    });
    this.editData = this.skillService.editDataCategory;
    this.editData.department.forEach(data => {
      this.deptId = data['department_id']
    });

    this.categoryForm.patchValue({
      'category_name': this.editData.category_name,
      'category_id': this.editData.category_id,
      'department_id': this.deptId
    });
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.unsubscribe();
    this.sub.unsubscribe();
  }

  locationBack() {
    this.location.back();
  }
  // onCheckChange(event) {
  //   const formArray: FormArray = this.categoryForm.get('department_id') as FormArray;
  //   if (event.target.checked) {
  //     formArray.push(new FormControl(Number(event.target.value)));
  //   }
  // }
  update(formData) {
    this.spinnerService.show();
    if (formData.valid) {
      this.skillService.updateNewCategory(formData.value).takeUntil(this.destroy).subscribe(data => {
        this.spinnerService.hide();
        this.router.navigateByUrl('categoryList')
      })
      this.flashService.show('Category name is updated successfully', 'alert-success');
    }
    else {
      this.spinnerService.hide();
      this.flashService.show('Edit category name or click cancel', 'alert-danger');
    }
  }
  trackByFn(index) {
    return index;
  }
}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/skill-matrix/edit-category/edit-category.component.ts